// extracted by mini-css-extract-plugin
export default {"cryptoContainer":"CryptoWidget_cryptoContainer__MYc5P","cryptoContainerScroll":"CryptoWidget_cryptoContainerScroll__LnBxz"};